<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";

   export default {
      page: {
         title: "Doctor Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Doctor Details",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            doctor: {},
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchDoctor();
      },
      methods: {

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchDoctor() {
            let url = "api/admin/pending_doctors/profile?id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.doctor = responseData.doctor;  

            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">
                        <div class="card overflow-hidden">
                           <div class="bg-soft bg-primary">
                              <div class="row m-0">
                                 <div class="col-7">
                                 
                                 </div>
                                 <div class="col-5 align-self-end">
                                    <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                                 </div>
                              </div>
                           </div>
                           <div class="card-body pt-2">
                              <div class="row">
                                 <div class="col-sm-4">
                                    <div class="avatar-md profile-user-wid mb-1">
                                       <img src="@/assets/images/no-user.jpg"
                                       alt
                                       class="img-thumbnail rounded-circle"
                                       />
                                    </div>
                                    
                                 </div>
                                 <div class="col-sm-8 align-self-center">
                                    <h5 class="font-size-15">
                                       <span v-if="doctor.prefix == 1">Dr.</span><span v-else-if="doctor.prefix == 2">Mr.</span><span v-else-if="doctor.prefix == 3">Ms.</span> {{doctor.name}} {{doctor.qualification}}
                                    </h5>
                                    <p class="font-size-14 mt-3 mb-1">
                                       <i class="bx bx-phone me-1 text-primary"></i> 
                                       +91 {{doctor.mobile}}
                                    </p>
                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-envelope me-1 text-primary"></i>
                                       {{doctor.email}}
                                    </p>

                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-map me-1 text-primary"></i>
                                       {{doctor.address}}
                                    </p>
                                 </div>
                              </div>                              

                           </div>
                        </div>
                        <!-- end card -->     
                        

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">ID Proof</h4>
                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3 font-size-18" v-for="(proof) in doctor.id_proofs" :key="proof.id">
                                 
                                 <!-- <a :href="$image_url + proof.id_proof" target="_blank"><p class="text-primary"><i class="fas fa-id-card me-3"></i> </p></a>   --> 

                                 <a :href="$image_url + proof.id_proof" target="_blank"><img :src="$image_url + proof.id_proof" class="w-100px" alt=""></a>  

                              </li>
                              
                           </ul>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Certificates</h4>
                           <div class="" v-if="doctor.certificates.length">
                              <ul class="list-inline p-0 m-0" >                     
                                 <li class="mb-3" v-for="(certificate) in doctor.certificates" :key="certificate.id">
                                    <a :href="$image_url + certificate.certificate" target="_blank"><p class="text-primary font-size-18"><i class="fas fa-file-alt me-3"></i></p></a>  
                                 </li>

                              </ul>
                           </div>
                           <div class="" v-else>
                              <p>No certificates added</p>
                           </div>
                        </b-card>

                     </div>

                     <div class="col-lg-7 col-md-7">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Doctor Details</h4>
                              

                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>
                                       
                                       <tr>
                                          <th width="45%">Gender</th>
                                          <th width="5%">:</th>
                                          <td width="50%">
                                             <span v-if="doctor.gender==1">Male</span>
                                             <span v-if="doctor.gender==2">Female</span>
                                             <span v-if="doctor.gender==3">Others</span>
                                          </td>
                                       </tr> 

                                       <tr>
                                          <th>D.O.B</th>
                                          <th>:</th>
                                          <td>{{doctor.dob | formatDate}}</td>
                                       </tr>  

                                        <tr>
                                          <th>Age</th>
                                          <th>:</th>
                                         <td>{{doctor.age}}</td>
                                       </tr>

                                       <tr>
                                          <th>Created on</th>
                                          <th>:</th>
                                          <td>{{doctor.converted_created_at}}</td>
                                       </tr>   
                                       <tr>
                                          <th>Created by</th>
                                          <th>:</th>
                                          <td>{{doctor.added_user_name}}</td>
                                       </tr>
                                       <tr>
                                          <th>Specializations</th>
                                          <th>:</th>
                                          <td>
                                             <span v-for="(specialization) in doctor.specializations" :key="specialization.id">
                                                {{specialization.specialization}}<br>
                                             </span>
                                          </td>
                                       </tr>     

                                       <tr>
                                          <th>Languages</th>
                                          <th>:</th>
                                          <td>
                                             <span v-for="(language) in doctor.languages" :key="language.id">
                                                {{language.language}}<br>
                                             </span>
                                          </td>
                                       </tr> 
                                         
                                    </tbody>
                                 </table>
                              </div>
                           
                        </b-card>
                        <!-- end card -->

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Registration Details</h4>                            
                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>                                       
                                       <tr>
                                          <th width="45%">Reg. No</th>
                                          <th width="5%">:</th>
                                          <td>{{doctor.reg_no}}</td>
                                       </tr>               
                                       
                                       <tr>
                                          <th>Reg. Council</th>
                                          <th>:</th>
                                          <td>{{doctor.reg_council}}</td>
                                       </tr>

                                       <tr>
                                          <th>Reg. Date:</th>
                                          <th>:</th>
                                          <td>{{doctor.reg_date | formatDate}}</td>
                                       </tr>     
                                    </tbody>
                                 </table>
                              </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Bank Details</h4>
                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody> 

                                       <tr>
                                          <th width="45%">Account No</th>
                                          <th width="5%">:</th>
                                          <td>{{doctor.account_no}}</td>
                                       </tr>

                                       <tr>
                                          <th>Account Holder Name</th>
                                          <th>:</th>
                                          <td>{{doctor.account_holder_name}}</td>
                                       </tr>          
                                       
                                       <tr>
                                          <th>IFSC Code</th>
                                          <th>:</th>
                                          <td>{{doctor.ifsc_code}}</td>
                                       </tr>

                                       <tr>
                                          <th>UPI ID</th>
                                          <th>:</th>
                                          <td>{{doctor.upi_id}}</td>
                                       </tr>   
                                    </tbody>
                                 </table>
                              </div>
                        </b-card>

                     </div>
                     
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

   </Layout>
</template>
